<template>
    <div v-if="!isMobile" class="wrapper">
        <div class="iphoneWrapper">
            <img class="iphoneInterface" src="/img/safari-apple-blinkl.png" @click="refreshIframe">
            <div class="browserViewport" />
        </div>
    </div>
    <div v-else class="wrapper">
        <v-btn class="custom_btn_add_field custom_btn_color_blue" @click="redirect">
            Tester la story
        </v-btn>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'Mobile',
        props: {
            data: {
                type: Object,
                default: () => {
                }
            },
            refresh: {
                type: Number,
                default: 0
            }
        },
        computed: {
            ...mapGetters('app', ['isMobile'])
        },
        watch: {
            refresh: function () {
                this.refreshIframe();
            }
        },
        mounted () {
            if (this.data.mode === 'story') {
                this.tryLoadStory();
            }
        },
        methods: {
            refreshIframe: function () {
                if (this.data.mode === 'story') {
                    let content = this.$el.querySelector('.browserViewport');
                    content.innerHTML = '';
                    this.tryLoadStory();
                }
            },
            redirect: function () {
                if (this.url !== 'none') {
                    window.open(this.url);
                }
            },
            tryLoadStory () {
                var xhr = new XMLHttpRequest();
                var method = 'GET';
                var url = 'story/' + this.data.id;
                xhr.open(method, url, true);
                xhr.onreadystatechange = () => {
                    let content = this.$el.querySelector('.browserViewport');
                    let head = document.getElementsByTagName('head')[0];
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        /** Load DOM Content **/
                        var newEl = document.createElement('html');
                        newEl.innerHTML = xhr.responseText;
                        content.innerHTML = newEl.querySelector('#BlinklActionTemplate').outerHTML;

                        /** Load Font Face **/
                        var newFontFace = document.createElement('link');
                        newFontFace.href = newEl.getElementsByTagName('head')[0].getElementsByTagName('link')[0].href;
                        newFontFace.rel = 'stylesheet';
                        head.appendChild(newFontFace);

                        /** Load Script **/
                        var newScript = document.createElement('script');
                        newScript.setAttribute('type', 'text/javascript');
                        newScript.text = newEl.querySelector('#BlinklActionScript').text;
                        content.append(newScript);
                        /*eslint-disable */
                        BlinklActionTemplateInit();
                        /* eslint-enable */
                    }
                };
                xhr.send();
            }
        }
    };
</script>

<style scoped>
    .custom_btn_add_field {
        margin: 40px 0 45px 0;
        height: 48px;
    }

    .wrapper {
        display: block;
        position: relative;
        width: 100%;
        overflow: auto;
        text-align: left;
    }

    .browserViewport {
        height: 481px;
        width: 297px;
        top: 15%;
        overflow: hidden;
        position: relative;
        left: 15.25%;
    }

    .browserViewport iframe {
        z-index: 1;
        position: absolute;
        height: 480px;
        width: 298px;
        left: 0;
    }

    .iphoneInterface {
        height: 100%;
        width: 100%;
        left: 0;
        position: absolute;
    }

    .iphoneWrapper {
        border-radius: 2px;
        height: 728px;
        left: 50%;
        overflow: hidden;
        position: relative;
        top: 0;
        -webkit-transform: translate(-50%, 0%);
        transform: translate(-50%, 0%);
        width: 430px;
        margin-bottom: 80px;
    }

</style>
